import { H4, LI, P, Image, UL } from "../../../../AbstractElements";
import ProductModal from "./ProductModal";
import React, { useEffect, useState } from "react";
import { Row, Card, Button, Spinner, Alert } from "reactstrap";
import bannerApi from "../../../../api/bannerAppCheckin";

const ProductGrid = () => {
  const layoutColumns = 3;
  const [dataid, setDataid] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load banners from API
  useEffect(() => {
    const loadBanners = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await bannerApi.getAll();
        
        // Ensure we have an array based on actual API response format
        let bannersArray = [];
        if (response && response.success && response.data && Array.isArray(response.data.banners)) {
          bannersArray = response.data.banners;
        } else if (Array.isArray(response)) {
          bannersArray = response;
        } else if (response && Array.isArray(response.data)) {
          bannersArray = response.data;
        } else if (response && Array.isArray(response.banners)) {
          bannersArray = response.banners;
        } else if (response && response.result && Array.isArray(response.result)) {
          bannersArray = response.result;
        } else {
          console.warn('⚠️ Unexpected response format:', response);
          bannersArray = [];
        }
        
        setBanners(bannersArray);
      } catch (err) {
        console.error('❌ Error loading banners:', err);
        setError('Không thể tải danh sách banner');
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };

    loadBanners();
  }, []);

  const onOpenModal = (bannerId) => {
    setOpenModal(true);
    setDataid(bannerId);
  };

  // Show loading state
  if (loading) {
    return (
      <React.Fragment>
        <div className="product-wrapper-grid" id="product-wrapper-grid">
          <Row className="gridRow" id="gridRow">
            <div className="col-12 text-center py-5">
              <Spinner color="primary" />
              <p className="mt-2 mb-0">Đang tải banners...</p>
            </div>
          </Row>
        </div>
      </React.Fragment>
    );
  }

  // Show error state
  if (error) {
    return (
      <React.Fragment>
        <div className="product-wrapper-grid" id="product-wrapper-grid">
          <Row className="gridRow" id="gridRow">
            <div className="col-12">
              <Alert color="danger">
                <strong>Lỗi:</strong> {error}
              </Alert>
            </div>
          </Row>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="product-wrapper-grid" id="product-wrapper-grid">
        <Row className="gridRow" id="gridRow">
          {banners && banners.length > 0 ? banners.map((banner, index) => (
            <div id="gridId" className={`${layoutColumns === 3 ? "col-xl-3 col-lg-6 col-sm-6 xl-4 box-col-4" : "col-xl-" + layoutColumns}`} key={`banner-${banner.id || index}`}>
              <Card>
                <div className="product-box">
                  <div className="product-img">
                    <span className="ribbon ribbon-info ribbon-right">Banner</span>
                    <Image attrImage={{ 
                      className: "img-fluid", 
                      src: banner.url, 
                      alt: banner.filename || "Banner",
                      onError: (e) => {
                        e.target.src = '/src/assets/images/dashboard/profile.png';
                      }
                    }} />
                    <div className="product-hover">
                      <UL attrUL={{ className: "simple-list d-flex flex-row" }}>
                        <LI attrLI={{ className: "border-0" }}>
                          <Button color="default" onClick={() => onOpenModal(`banner-${banner.id || index}`)}>
                            <i className="icon-eye"></i>
                          </Button>
                        </LI>
                      </UL>
                    </div>
                  </div>
                  <div className="product-details">
                    <H4>Banner {banner.filename || `#${banner.id || index}`}</H4>
                    <P>Size: {(banner.size / 1024).toFixed(1)} KB</P>
                    <div className="product-price">
                      <span className="text-success">API Banner</span>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          )) : (
            <div className="col-12 text-center py-5">
              <p>Không có banner nào để hiển thị</p>
            </div>
          )}
          {openModal && <ProductModal value={openModal} setOpenModal={setOpenModal} dataid={dataid} banners={banners} />}
        </Row>
      </div>
    </React.Fragment>
  );
};
export default ProductGrid;
